import { Box, Button, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';

export const SelectFromNameValueArray = ({
  array = [],
  nameKey,
  valueKey,
  onSelect,
  onCancel,
  label,
  multiple = false,
  selectedValues = [],
}) => {
  const { t } = useTranslation();

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    setSelected(selectedValues || []);
  }, [selectedValues]);

  // handle item click
  function handleItemClick(value, element) {
    if (!multiple) {
      onSelect(value, element);
      return;
    }

    // toggle selection betweeen selected and not selected
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  }

  function handleSave() {
    onSelect(selected);
  }

  return (
    <Box className="h-full w-full flex flex-col gap-2 items-center">
      <Typography variant="h3" className="pt-5 pb-5" textAlign="center">
        {t(label)}
      </Typography>

      <Box className="w-full flex flex-col gap-2 items-center overflow-auto">
        {array &&
          array.map((element) => {
            const value = element[valueKey];

            return (
              <ListItem
                key={`${element[nameKey]}-${element[valueKey]}`}
                name={element[nameKey]}
                value={value}
                element={element}
                selected={selected.includes(value)}
                onClick={handleItemClick}
              />
            );
          })}
      </Box>

      {multiple && (
        <Box className="w-full flex justify-between p-4">
          <Button variant="outlined" color="error" onClick={onCancel}>
            {t('Cancel')}
          </Button>

          <Button variant="contained" color="success" onClick={handleSave}>
            {t('Save')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

const ListItem = ({ name, value, onClick, element, selected = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Button
      onClick={() => onClick(value, element)}
      sx={{
        width: '90%',
        justifyContent: 'center',
        border: selected ? `1px solid ${colors.info}` : '1px solid transparent',
        bgcolor: selected ? colors.info + '30' : 'transparent',
        ':hover': {
          bgcolor: colors.info + '30',
          borderColor: colors.info,
        },
      }}
    >
      <Typography textAlign="right" className="pr-4">
        {name}
      </Typography>
      <ArrowForwardIosIcon fontSize="15px" className=" opacity-25" />
      <Typography className="pl-4" textAlign="left">
        {value}
      </Typography>
    </Button>
  );
};
